import { render, staticRenderFns } from "./SimpleMetricsCard.vue?vue&type=template&id=48cd4747&"
import script from "./SimpleMetricsCard.vue?vue&type=script&lang=ts&"
export * from "./SimpleMetricsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports